import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

/** Y = retain technical terms in English; N = no special technical-term rule. */
export type KeepTechnicalInEnglish = 'Y' | 'N';
/** ROMAN = Latin letters for retained English technical words; NATIVE = target language script. */
export type TechnicalEnglishScript = 'ROMAN' | 'NATIVE';

export interface LanguageRow {
  LanguageShortCode: string;
  LanguageName: string;
  /** Native script label for AI prompt, e.g. Devanagari for Hindi. */
  ScriptName?: string;
  TranslationInstruction: string;
  KeepTechnicalInEnglish?: KeepTechnicalInEnglish;
  TechnicalEnglishScript?: TechnicalEnglishScript;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private apiUrl = `${environment.baseUrl}/languages`;

  constructor(private commonAPI: CommonApiService) {}

  getLanguages(): Observable<LanguageRow[]> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/languages`, { criteria: { tenant: null } });
  }

  addLanguage(row: Partial<LanguageRow>): Observable<any> {
    const body = {
      criteria: {
        LanguageShortCode: row.LanguageShortCode,
        LanguageName: row.LanguageName,
        ScriptName: row.ScriptName || '',
        TranslationInstruction: row.TranslationInstruction || '',
        KeepTechnicalInEnglish: row.KeepTechnicalInEnglish || 'Y',
        TechnicalEnglishScript: row.TechnicalEnglishScript || 'ROMAN',
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/addLanguage`, body);
  }

  updateLanguage(row: Partial<LanguageRow>): Observable<any> {
    const body = {
      criteria: {
        LanguageShortCode: row.LanguageShortCode,
        LanguageName: row.LanguageName,
        ScriptName: row.ScriptName,
        TranslationInstruction: row.TranslationInstruction,
        KeepTechnicalInEnglish: row.KeepTechnicalInEnglish,
        TechnicalEnglishScript: row.TechnicalEnglishScript,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.apiUrl}/updateLanguage`, body);
  }

  getProjectTranslationLanguages(projectId: string): Observable<LanguageRow[]> {
    const body = { criteria: { projectId, tenant: null } };
    return this.commonAPI.postApiCall(`${this.apiUrl}/projectTranslationLanguages`, body);
  }
}
